import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { PageStatusQuery } from '../graphql/PageStatusQuery.graphql.ts';

// Dev note: If this is changed, also update `preloadPageStatusQuery` in preloadLivePageRoute.ts
export function preloadPageStatusQuery(contentId: string) {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: PageStatusQuery,
		variables: {
			contentId,
		},
	});
}
